import type { IconData } from '@stacksjs/iconify-core'

export const calendarAltF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M17 2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3v2a2 2 0 1 0 4 0V2h1v2a2 2 0 1 0 4 0V2h1v2a2 2 0 1 0 4 0zM3 8v2h2V8zm0 4v2h2v-2zm12 0v2h2v-2zm0-4v2h2V8zM7 8v2h2V8zm4 0v2h2V8zm0 4v2h2v-2zm-4 0v2h2v-2zM5 0a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1m10 0a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1m-5 0a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default calendarAltF
